<mat-toolbar>
    <p class="d-flex m-auto font-14">Copyrights &copy; Giant Data Safe {{currentYear}}</p>
</mat-toolbar>
